// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ai-avatar{width:48px;height:48px;border-radius:50%;margin:0 15px 0 20px}.ai-avatar .avatar-img{width:48px;height:48px;max-width:none}", ""]);
// Exports
module.exports = exports;
